module.exports = __webpack_public_path__ + "img/officePic1.a4499dc6.jpg";